<h3 sidenav-title>{{ 'Advanced Filters' }}</h3>

<sidenav-content>
    <form [formGroup]="formGroup">
        <div class="form-group">
            <sidenav-label>{{ 'Submission State' }}</sidenav-label>
            <mat-radio-group formControlName="state">
                <mat-radio-button *ngFor="let state of formSubmissionStates | keyvalue: originalOrder"
                                  value="{{ state.value }}"
                                  disableRipple>
                    {{ state.value | capitalize }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="form-group">
            <sidenav-label>{{ 'Form State' }}</sidenav-label>
            <mat-radio-group formControlName="formState">
                <mat-radio-button *ngFor="let formState of formStatuses | keyvalue: originalOrder"
                                  value="{{ formState.value.toLowerCase() }}"
                                  disableRipple>
                    {{ formState.value | capitalize }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </form>
</sidenav-content>

<sidenav-actions>
    <button mat-flat-button disableRipple color="primary" (click)="applyFilters()">{{ 'Apply Filters' }}</button>
    <button-spacer></button-spacer>
    <button mat-flat-button disableRipple color="accent" sidenav-close>{{ 'Close' }}</button>
</sidenav-actions>
